import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Fecha', accessor: 'day' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function Holiday(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [holidays, setHolidays] = useState([]); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false); //Feedback visual para carga de datos

  //recargar Listado para usar en create y update
  async function loadHolidays() {
    setDataLoading(true);
    let response = await wsGetAll('base/holiday');
    setDataLoading(false);
    if (response.success) setHolidays(response.data);
  }

  useEffect(() => {
    loadHolidays();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadHolidays} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de Feriados {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Feriados"
              defaultWidth={1000}
              indexRow={[0, 4]}
              widthRow={[130, 5]}
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={holidays.map((holiday, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <Button
                        justIcon
                        round
                        simple
                        color="info"
                        onClick={() => setOpen(holiday)}
                        className="like"
                      >
                        <Create />
                      </Button>
                      <ButtonDelete entity="base/holiday" id={holiday.id} reload={loadHolidays} />
                    </div>
                  ),
                  day: holiday.day,
                  description: holiday.description,
                  state: holiday.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
